import * as React from 'react';
import PropTypes from 'prop-types';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';

import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';

import { visuallyHidden } from '@mui/utils';


function createData(id, name, calories, fat, carbs, protein, vitamin, minreal, satfats, actions) {
    return {
        id,
        name,
        calories,
        fat,
        carbs,
        protein,
        vitamin, minreal, satfats, actions
    };
}

const rows = [
    createData(0, '10/01/2024  8:19:36', 'John Dawn',  '142.120.0.11',),
    createData(1, '10/01/2024  8:19:36', 'John Dawn', '142.120.0.11',),
];

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        label: 'Date & Time',
    },
    {
        id: 'calories',
        numeric: true,
        disablePadding: false,
        label: 'User',
    },
    // {
    //     id: 'fat',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Event',
    // },
    {
        id: 'carbs',
        numeric: true,
        disablePadding: false,
        label: 'Ip Address',
    },
    // {
    //     id: 'protein',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Show Review',
    // },
    // {
    //     id: 'vitamin',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'City',
    // },
    // {
    //     id: 'minreal',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Status',
    // },
    // {
    //     id: 'satfats',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Comments',
    // },

    // {
    //     id: 'actions',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Actions',
    // },

];

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        // align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (<></>
        // <Toolbar
        //     sx={{
        //         pl: { sm: 2 },
        //         pr: { xs: 1, sm: 1 },
        //         ...(numSelected > 0 && {
        //             bgcolor: (theme) =>
        //                 alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        //         }),
        //     }}
        // >
        //     {numSelected > 0 ? (
        //         <Typography
        //             sx={{ flex: '1 1 100%' }}
        //             color="inherit"
        //             variant="subtitle1"
        //             component="div"
        //         >
        //             {numSelected} selected
        //         </Typography>
        //     ) : (
        //         <Typography
        //             sx={{ flex: '1 1 100%' }}
        //             variant="h6"
        //             id="tableTitle"
        //             component="div"
        //         >
        //             Nutrition
        //         </Typography>
        //     )}

        //     {numSelected > 0 ? (
        //         <Tooltip title="Delete">
        //             <IconButton>
        //                 <DeleteIcon />
        //             </IconButton>
        //         </Tooltip>
        //     ) : (
        //         <Tooltip title="Filter list">
        //             <IconButton>
        //                 <FilterListIcon />
        //             </IconButton>
        //         </Tooltip>
        //     )}
        // </Toolbar>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};
export const Loginlogs = () => {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);

  const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
      if (event.target.checked) {
          const newSelected = rows.map((n) => n.id);
          setSelected(newSelected);
          return;
      }
      setSelected([]);
  };

  const handleClick = (event, id) => {
      const selectedIndex = selected.indexOf(id);
      let newSelected = [];

      if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, id);
      } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
              selected.slice(0, selectedIndex),
              selected.slice(selectedIndex + 1),
          );
      }
      setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
      setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
  };

  const handleChangeDense = (event) => {
      setDense(event.target.checked);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
      page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
      () =>
          stableSort(rows, getComparator(order, orderBy)).slice(
              page * rowsPerPage,
              page * rowsPerPage + rowsPerPage,
          ),
      [order, orderBy, page, rowsPerPage],
  );

  const [age, setAge] = React.useState('');
  const handleChange = (event) => {
      setAge(event.target.value);
    };

  return (
      <div className='tableDesigned'>
          <Box>
              <Paper>
                  <EnhancedTableToolbar numSelected={selected.length} />
                  <TableContainer>
                      <Table>
                          <EnhancedTableHead
                              numSelected={selected.length}
                              order={order}
                              orderBy={orderBy}
                              onSelectAllClick={handleSelectAllClick}
                              onRequestSort={handleRequestSort}
                              rowCount={rows.length}
                          />
                          <TableBody>
                              {visibleRows.map((row, index) => {
                                  const isItemSelected = isSelected(row.id);
                                  const labelId = `enhanced-table-checkbox-${index}`;

                                  return (
                                      <TableRow
                                          hover
                                          onClick={(event) => handleClick(event, row.id)}
                                          role="checkbox"
                                          aria-checked={isItemSelected}
                                          tabIndex={-1}
                                          key={row.id}
                                          selected={isItemSelected}
                                          sx={{ cursor: 'pointer' }}
                                      >
                                          <TableCell padding="checkbox">
                                              <Checkbox
                                                  color="primary"
                                                  checked={isItemSelected}
                                                  inputProps={{
                                                      'aria-labelledby': labelId,
                                                  }}
                                              />
                                          </TableCell>
                                          <TableCell
                                              component="th"
                                              id={labelId}
                                              scope="row"
                                              padding="none"
                                          >
                                              {row.name}
                                          </TableCell>
                                          <TableCell>{row.calories}</TableCell>
                                          <TableCell >{row.fat}</TableCell>
                                          <TableCell >{row.carbs}</TableCell>

                                          {/* <TableCell >{row.vitamin}</TableCell>
                                          <TableCell >
                                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                  <Select
                                                      value={age}
                                                      onChange={handleChange}
                                                      displayEmpty
                                                      inputProps={{ 'aria-label': 'Without label' }}
                                                      size="small">
                                                      <MenuItem value="">
                                                          <em>None</em>
                                                      </MenuItem>
                                                      <MenuItem value={10}>Ten</MenuItem>
                                                      <MenuItem value={20}>Twenty</MenuItem>
                                                      <MenuItem value={30}>Thirty</MenuItem>
                                                  </Select>
                                                 
                                              </FormControl>
                                          </TableCell>
                                          <TableCell >{row.satfats}</TableCell>
                                          <TableCell >
                                              <div className="btn-groups">
                                                  <button className='actionbuttons'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                      <path d="M20.4908 11.1432C20.8361 11.6696 20.8361 12.3304 20.4908 12.8568C19.4032 14.5146 16.5729 18 11.9999 18C7.4269 18 4.5966 14.5146 3.50898 12.8568C3.16367 12.3304 3.16367 11.6696 3.50898 11.1432C4.5966 9.48535 7.4269 6 11.9999 6C16.5729 6 19.4032 9.48535 20.4908 11.1432Z" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round" />
                                                      <path d="M15 12C15 13.6569 13.6568 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6568 9 15 10.3431 15 12Z" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round" />
                                                  </svg></button>
                                                  <button className='actionbuttons'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                      <path d="M18 10V9.82843C18 9.29799 17.7893 8.78929 17.4142 8.41421L13.5858 4.58579C13.2107 4.21071 12.702 4 12.1716 4H12M18 10V18C18 19.1046 17.1046 20 16 20H13M18 10H14C12.8954 10 12 9.10457 12 8V4M12 4H8C6.89543 4 6 4.89543 6 6V13M6 20V17.5M6 20V22.5M6 20H3.5M6 20H8.5" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round" />
                                                  </svg></button>
                                                  <button className='actionbuttons'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                      <path d="M16.5 3.5H18.5C19.6046 3.5 20.5 4.39543 20.5 5.5V7.5M16.5 20.5H18.5C19.6046 20.5 20.5 19.6046 20.5 18.5V16.5M7.5 3.5H5.5C4.39543 3.5 3.5 4.39543 3.5 5.5V7.5M7.5 20.5H5.5C4.39543 20.5 3.5 19.6046 3.5 18.5V16.5M7.5 17.5H9.5C10.0523 17.5 10.5 17.0523 10.5 16.5V14.5C10.5 13.9477 10.0523 13.5 9.5 13.5H7.5C6.94772 13.5 6.5 13.9477 6.5 14.5V16.5C6.5 17.0523 6.94772 17.5 7.5 17.5ZM14.5 14C14.5 14.2761 14.2761 14.5 14 14.5C13.7239 14.5 13.5 14.2761 13.5 14C13.5 13.7239 13.7239 13.5 14 13.5C14.2761 13.5 14.5 13.7239 14.5 14ZM14.5 17C14.5 17.2761 14.2761 17.5 14 17.5C13.7239 17.5 13.5 17.2761 13.5 17C13.5 16.7239 13.7239 16.5 14 16.5C14.2761 16.5 14.5 16.7239 14.5 17ZM17.5 17C17.5 17.2761 17.2761 17.5 17 17.5C16.7239 17.5 16.5 17.2761 16.5 17C16.5 16.7239 16.7239 16.5 17 16.5C17.2761 16.5 17.5 16.7239 17.5 17ZM17.5 14C17.5 14.2761 17.2761 14.5 17 14.5C16.7239 14.5 16.5 14.2761 16.5 14C16.5 13.7239 16.7239 13.5 17 13.5C17.2761 13.5 17.5 13.7239 17.5 14ZM7.5 10.5H9.5C10.0523 10.5 10.5 10.0523 10.5 9.5V7.5C10.5 6.94772 10.0523 6.5 9.5 6.5H7.5C6.94772 6.5 6.5 6.94772 6.5 7.5V9.5C6.5 10.0523 6.94772 10.5 7.5 10.5ZM14.5 10.5H16.5C17.0523 10.5 17.5 10.0523 17.5 9.5V7.5C17.5 6.94772 17.0523 6.5 16.5 6.5H14.5C13.9477 6.5 13.5 6.94772 13.5 7.5V9.5C13.5 10.0523 13.9477 10.5 14.5 10.5Z" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round" />
                                                  </svg></button>
                                              </div>
                                          </TableCell> */}

                                      </TableRow>
                                  );
                              })}
                              {emptyRows > 0 && (
                                  <TableRow
                                      style={{
                                          height: (dense ? 33 : 53) * emptyRows,
                                      }}
                                  >
                                      <TableCell colSpan={6} />
                                  </TableRow>
                              )}
                          </TableBody>
                      </Table>
                  </TableContainer>
                  <TablePagination
                      rowsPerPageOptions={[5, 10, 25 , 50, 100]}
                      component="div"
                      count={rows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                  />
              </Paper>
          </Box>
      </div>
  );
}



